import { createAction } from 'redux-act';

import {
	IError,
} from "../reducers";

export const errorsShowGlobalError = createAction<IError>('Error Show Global Error');
export const errorsGlobalError = createAction<ErrorEvent>('Error Global Error');
export const errorsClearGlobalError = createAction('Error Clear Global Error');